/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { flowRight } from 'lodash'
import Form, { Values } from 'react-trazo-forms'
import {
  getInformationFields,
  informationInitialValues,
  informationValidationSchema,
} from '../../forms/wizard/information'
import withCongress, { ComponentProps } from '../../../../providers/Congress/withCongress'
import withReservation, { ReservationProps } from '../../../../providers/Reservation/withReservation'
import { RouterItem } from '../../../../config/router.config'
import withWizardProps, { WizardProps } from '../../../../wrappers/withWizardParams'
import { getReservation, purchase, saveRegistration } from '../../../../requests/inscription'
import { uploadPDF } from '../../../../requests/gallery'
import { getNextWizardPath } from '../../../../helpers/wizard'
import { message } from 'antd'
import DetailResolver from '../../../../components/Resolvers/DetailResolver'
import LoaderWrapper from '../../../../components/Utils/LoaderWrapper'
import Row from '../../../../components/Form/Row'
import Section from '../../../../components/Section/Section'
import Col from '../../../../components/Form/Col'
import CustomButton from '../../../../components/Utils/Button'
import withURLParams, { URLParamsComponentProps } from '../../../../providers/URLParams/withURLParams'
import styled from 'styled-components'
import { countryWithCode } from '../../../../helpers/forms'
import { Button } from 'antd'

interface Props extends ComponentProps, RouteComponentProps, WizardProps, ReservationProps, URLParamsComponentProps {
  step: RouterItem;
  nextStep: RouterItem;
}

interface FormValues {
  Email?: any,
  FirstName?: any,
  LastName?: any,
  Country?: any,
  Region?: any,
  CompanyName?: any,
  JobTitle?: any,
  Gender?: any,
  AgeRange?: any,
  Voucher?: string,
  VoucherCourse?: string,
  Phone?: any,
  Becado?: any,
  BecadoTaller?: any,
  Course?: any,
  FileCongress?: any,
  FileCourse?: any,
  AssistanceEvent?: any,
  CourseVoucher?: any,
  Role?: any,
}


interface State {
  values: FormValues,
  isValid: boolean,
  isLoading: boolean,
  prices: any,
  isInitialValid: boolean,
  pdfLoading: any,
  phone: any,
  fileCongress: string,
  tempFileCongress: any,
  fileCongressName: string,
  fileCourse: string,
  tempFileCourse: any,
  fileCourseName: string,
}

class Payment extends React.Component<Props, State> {
  state = {
    values: {
      Email: null,
      FirstName: null,
      LastName: null,
      Country: null,
      Region: null,
      CompanyName: null,
      JobTitle: null,
      Gender: null,
      AgeRange: null,
      CouponCode: null,
      Voucher: "",
      VoucherCourse: "",
      Phone: null,
      Becado: "PAGADO PARTICULAR",
      BecadoTaller: "PAGADO PARTICULAR",
      Course: "",
      FileCongress: "",
      FileCourse: "",
      AssistanceEvent: "",
      Role: "",
    },
    phone: null,
    isValid: true,
    isLoading: false,
    prices: [],
    isInitialValid: false,
    pdfLoading: false,
    fileCongress: "",
    tempFileCongress: "",
    fileCongressName: "",
    fileCourse: "",
    tempFileCourse: "",
    fileCourseName: "",
  }

  beforeUploadCongress = (e: any) => {
    this.handleUploadFile(e.target.files[0], "congress")
  }

  beforeUploadBLS = (e: any) => {
    this.handleUploadFile(e.target.files[0], "bls")
  }

  handleUploadFile = async (val: any, voucherType: string)=> {
    const { reservation } = this.props
    try {
      this.setState({ pdfLoading: true })
      if (voucherType === "congress") {
        await this.setState({ tempFileCongress: val, fileCongressName: val.name })
      } else {
        await this.setState({ tempFileCourse: val, fileCourseName: val.name })
      }

      const formData = new FormData()
      formData.append('CongressSlug', reservation.data.CongressSlug )
      formData.append('File', val, val.name )
      const resp = await uploadPDF( null, formData)
      if (voucherType === "congress") {
        this.setState({fileCongress: resp.Data.URL})
      } else {
        this.setState({fileCourse: resp.Data.URL})
      }
    }catch(e) {
      console.log('err', e)
    } finally {
      this.setState({ pdfLoading: false })
    }
  }

  handleFormSubmit = async() => {
    const { values, fileCongress, fileCourse, phone } = this.state
    const { wizard, congress } = this.props
    this.setState({ isLoading: true })

    const copyOfValues = { ...values }
    copyOfValues.Voucher = fileCongress ? fileCongress : values.Voucher
    copyOfValues.VoucherCourse = fileCourse ? fileCourse : values.VoucherCourse

    saveRegistration({ id: wizard.token }, {
      Information: copyOfValues,
      Country: values.Country,
      Becado: values.Becado,
    })
      .then(async (resp: any) => {
        if (congress.Slug != "veterinario-virtual-2022"){
          const formData = new FormData()
          formData.append('FinishingSource', 'forms' )
          formData.append('PaymentMethod', 'None' )
          if (copyOfValues.CouponCode) {
            formData.append('CouponCode', copyOfValues.CouponCode || "" )
          }
          purchase({ id: wizard.token }, formData)
          .then((resp) => {
            this.handleSuccess()
          })
          .catch((resp: any) => {
            if(resp.message === 'coupon: record not found') {
              message.error('El código de cortesía ingresado ya se registró o no existe')
            } else {
              message.error(resp.message)
            }
          })
          .finally(() => {
            this.setState({ isLoading: false })
          })
        } else {
          this.handleSuccess()
        }
      })
      .catch((resp: any) => {
        message.error(resp.message)
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  handleSuccess = () => {
    const { history, wizard, congress, step } = this.props
    const nextPath = getNextWizardPath(wizard.token, congress.Slug, step.slug)
    history.push(nextPath)
  }

  handleResolve = async (data: any, callback: () => void) => {
    try {
      // await this.getPriceList()
      const isValid = await informationValidationSchema.validate(data.Data)
      this.setState({ isInitialValid: true, phone: data.Data.Phone || "" })
    } catch (e) {
      console.log('Initial data is not valid', e)
    } finally {
      callback()
    }
  }

  render () {
    const { reservation } = this.props

    return (
      <DetailResolver
        requestFunction={() => getReservation({ id: reservation.data.UUID })}
        render={this.renderContent}
        onResolve={this.handleResolve}
      />
    )
  }

  renderContent = (data: any) => {
    const { isLoading, isInitialValid, pdfLoading, values } = this.state
    const { congress } = this.props
    const index = countryWithCode.findIndex((country) => country.nombre == values.Country)
    const countryCode = countryWithCode[Math.max(index, 0)].iso2.toString()
    return (
      <LoaderWrapper isLoading={isLoading || pdfLoading}>
        <Form
          initialValues={informationInitialValues(data.Data)}
          fields={getInformationFields(congress.Slug)}
          validationSchema={informationValidationSchema}
          onChange={(values: Values, isValid: boolean) => this.setState({ values, isValid })}
          isInitialValid={isInitialValid}
        >
          {this.renderForm(data.Data, countryCode)}
        </Form>
      </LoaderWrapper>
    )
  }

  renderForm = (data: any, countryCode: any) => () => {
    const { fileCongress, fileCourse, values } = this.state
    const { congress } = this.props

    let sourceVoucher = fileCongress ? fileCongress : values.Voucher && values.Voucher !== "" ? values.Voucher : ""
    let sourceCourse = fileCourse ? fileCourse : values.VoucherCourse && values.VoucherCourse !== "" ? values.VoucherCourse : ""

    if (sourceVoucher.endsWith("pdf")) {
      sourceVoucher = ""
    }

    if (sourceCourse.endsWith("pdf")) {
      sourceCourse = ""
    }

    let courseValues = ""
    let totalValues = values.Role === "Estudiante" ? " CLP $50.000 si estás en Chile o USD 65 si estás en el extranjero" : " CLP $150.000 si estás en Chile o USD 190 si estás en el extranjero"
    if (values.AssistanceEvent !== "Asistiré sólo al congreso") {
      if (values.Course === "CERTIFICACION EN RCP RECOVER") {
        courseValues = " CLP $495.000 si estás en Chile o USD 550 si estás en el extranjero"
        totalValues = values.Role === "Estudiante" ? " CLP $545.000 si estás en Chile o USD 615 si estás en el extranjero" : " CLP $645.000 si estás en Chile o USD 740 si estás en el extranjero"
      }

      if (values.Course === "MANIOBRAS CLÍNICAS AVANZADAS DE EMERGENCIAS" || values.Course === "COMUNICACIÓN Y HABILIDADES BLANDAS EN ER") {
        courseValues = " CLP $261.000 si estás en Chile o USD 290 si estás en el extranjero"
        totalValues = values.Role === "Estudiante" ? " CLP $311.000 si estás en Chile o USD 355 si estás en el extranjero" : " CLP $411.000 si estás en Chile o USD 480 si estás en el extranjero"
      }

      if (values.Course === "POCUS ULTRASONIDO EN EMERGENCIA" || values.Course === "DIÁLISIS PERITONEAL") {
        courseValues = " CLP $225.000 si estás en Chile o USD 250 si estás en el extranjero"
        totalValues = values.Role === "Estudiante" ? " CLP $275.000 si estás en Chile o USD 315 si estás en el extranjero" : " CLP $375.000 si estás en Chile o USD 440 si estás en el extranjero"
      }

    }

    return (
      <React.Fragment>
         <Section>
            <h2>Información de pago de congreso</h2>
            <Row gutter={32}>
              <Col md={24}>
                <h3>Si necesitas realizar un pago puedes hacerlo en el siguiente botón.</h3>
                <h3>Según tu selección, y si no estas becado por una empresa, debes pagar un <b> total de {totalValues}</b>.</h3>
                <a href="https://congresoveterinario.cl/payment/method" target='_blank'>
                  <Button type="primary" style={{ marginBottom: 24}}>
                    Realizar Pago 
                  </Button>
                </a>
              </Col>  
              {/* <Col md={12}></Col> */}
            </Row>
          </Section>
        {values.AssistanceEvent != "Asistiré sólo a un taller de pago" ? (
          <Section>
            
            <h3>El valor a pagar es de 
              {values.Role === "Estudiante" ? " CLP $50.000 si estás en Chile o USD 65 si estás en el extranjero" : " CLP $150.000 si estás en Chile o USD 190 si estás en el extranjero"}
            </h3>

            <Row gutter={32}>
              <Col md={12}>
                <Form.Field name="Becado"/>
              </Col>
            <Col md={12} />
            </Row>
            {values.Becado == "PAGADO PARTICULAR" ? (
              <Row gutter={32}>
                <Col md={8}>
                  <VoucherContainer>
                    <Label>Subir comprobante de pago del congreso </Label>
                  </VoucherContainer>
                  <form method="post" encType="multipart/form-data" style={{ width: "100%", marginBottom: 22}}>
                    <input type="file" className="custom-file-input" onChange={this.beforeUploadCongress}/>
                  </form>
                  {fileCongress !== "" || values.Voucher !== "" && sourceVoucher !== "" ? <a href={sourceVoucher} target='blank' > <img src={sourceVoucher} style={{ height: 50, borderRadius: 8 }}/></a> : null}
                  {fileCongress !== "" || values.Voucher !== "" ? <h4>¡Archivo cargado!</h4> : <h4/>}
                </Col>  
                <Col md={16}></Col>
              </Row>
            ) : null}
          </Section>
        ) : null}

        {values.AssistanceEvent !== "Asistiré sólo al congreso" ? (
          <Section>
            <h3>Seleccionaste el taller "{values.Course}"</h3>
            <h3>El valor a pagar es de {courseValues}</h3>
            <Row gutter={32}>
              <Col md={12}>
                <Form.Field name="BecadoTaller"/>
              </Col>
              <Col md={12} />
            </Row>
            {values.BecadoTaller == "PAGADO PARTICULAR" ? (
              <Row gutter={32}>
                <Col md={8}>
                  {console.log("Values: ", values)}
                  <VoucherContainer>
                    <Label>Subir comprobante de pago del taller</Label>
                    
                  </VoucherContainer>
                  <form method="post" encType="multipart/form-data" style={{ width: "100%", marginBottom: 22}}>
                    <input type="file" className="custom-file-input" onChange={this.beforeUploadBLS}/>
                  </form>
                  {console.log("values.VoucherCourse: ", values.VoucherCourse !== "")}
                  {console.log("fileCourse: ", fileCourse !== "")}
                  {fileCourse !== "" || values.VoucherCourse !== "" && sourceCourse !== "" ? <a href={sourceCourse} target='blank' > <img src={sourceCourse} style={{ height: 50, borderRadius: 8 }}/></a> : null}
                  {fileCourse !== "" || values.VoucherCourse !== "" ? <h4>¡Archivo cargado!</h4> : <h4/>}
                </Col>  
                <Col md={16}></Col>
              </Row>
               ) : null}
          </Section>
        ) : null}

         

        {this.renderActionButton(data)}
      </React.Fragment>
    )
  }

  renderActionButton (data: any) {
    const { isLoading, values, fileCongress, fileCourse } = this.state
    const { congress, nextStep } = this.props
    var message = ''
    console.log("Values in BUtton render: ", values)
    if (values.Becado === "PAGADO PARTICULAR") {
      let hasVoucher = fileCongress !== "" || values.Voucher !== ""
      if (!hasVoucher) {
        message = 'Si no eres becado, debes subir el comprobante de pago del congreso'
      }
    } 

    if (values.BecadoTaller === "PAGADO PARTICULAR") {
      let hasVoucher = fileCourse !== "" || values.VoucherCourse !== ""
      if (!hasVoucher) {
        message = 'Si no eres becado, debes subir el comprobante de pago del taller'
      }
    } 

    if (values.AssistanceEvent != "Asistiré sólo a un taller de pago") {
      if (values.Becado === "") {
        message = 'Seleccione una opción para: ¿Ha realizado su pago a alguna institución o ha sido becado por alguna empresa?'
      }
    }

    if (values.AssistanceEvent != "Asistiré sólo al congreso") {
      if (values.BecadoTaller === "") {
        message = '¿Ha realizado su pago a alguna institución o ha sido becado por alguna empresa para el taller?'
      }
    }

    return (
      <Section align="center">
        <CustomButton
          disabledMessage={message}
          color={congress.PrimaryColor}
          disabled={isLoading || message !== "" }
          onClick={this.handleFormSubmit}>
            Finalizar Inscripción
        </CustomButton>
      </Section>
    )
  }
}

const Label = styled.p`
  color: rgba(0, 0, 0, 0.85);
  text-align: start;
  position: relative;
  line-height: 39.9999px;
  white-space: nowrap;
  width: 100%;
`

const VoucherContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  
  @media screen and (max-width: 768px) {
    flex-direction: col !important;
    justify-content: start;
  }
`

export default flowRight([withCongress, withWizardProps, withReservation, withURLParams])(Payment)
